import { ListColumn } from './ListColumn';
import { OPERATORS, TYPES } from '../../../common/list-utils';
import { ICalendarProps, IComboBoxOption, IDropdownOption } from '@fluentui/react';
import { OrganizationChartNode } from '../../../system/organization_chart/OrganizationChartNode';

export interface ICheckboxCustom {
  key:string;
  text: string;
  checked: boolean;
  active?: "1" | "0";
}

export class ListColumnFilter /* extends ListColumn */ {
  name: string;
  quick?: boolean;
  type: string;
  operator: string;
  placeholder?: string;
  contextForDropdown?: IDropdownOption<any>[];
  contextForCombobox?: IComboBoxOption[];
  CheckboxCustom?:ICheckboxCustom[];
  contextForOrganizationChartDropdown?: OrganizationChartNode[];
  labelForCheckbox?: string;
  checkBoxValue?: string;
  grow?: number;
  defaultValue?: string | Date | number;
  hidden?: boolean;
  disabled?: boolean;
  example?: string;
  calendarProps?: ICalendarProps | undefined;
  isMonthSelector?: boolean| undefined;
  formatDate?: ((date?: Date | undefined) => string) | undefined
  required?: boolean;

  constructor(
      type: string = TYPES.INPUT,
      operator: string = OPERATORS.CONTAINS,
      name: string,
      prop: string,
      grow: number,
      defaultValue?: string | Date,
      hidden?: boolean | null,
      disabled?: boolean | null,
      example?: string | null,
      required?: boolean
  ) {
    this.type = type;
    if (type === TYPES.CHECKBOX) {
      this.labelForCheckbox = name;
      this.checkBoxValue = '1';
    }
    this.name = prop;
    this.operator = operator;
    this.placeholder = name;
    this.grow = grow;
    this.defaultValue = defaultValue ? defaultValue : '';
    this.hidden = hidden ? hidden : false;
    this.disabled = disabled ? disabled : false;
    this.example = example ? example : '';
    this.required = required ? required : false;
  }
}

// export const getFiltersConfig = (listColums: ListColumn<any>[]) => {
export const getFiltersConfig = (listColums: any) => {
  let _filtersConfig: any[] = [];
  listColums.forEach((col: any) => {
    if (col) {
      _filtersConfig.push(col);
    }
  });

  return _filtersConfig;
};
